import template from './flight-group.html';

const DIRECTIVE_NAME = AtcFlightGroup.DIRECTIVE_NAME = 'ktAtcFlightGroup';
export default function AtcFlightGroup() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: AtcFlightGroupController,
        controllerAs: '$ctrl',
        scope: {
            group: `=${DIRECTIVE_NAME}`,
            recommendation: `=${DIRECTIVE_NAME}Recommendation`,
            selectedFlights: `=${DIRECTIVE_NAME}SelectedFlights`,
            searchParameters: `=${DIRECTIVE_NAME}SearchParameters`,
            isDepartureHighlighted: `=?${DIRECTIVE_NAME}IsDepartureHighlighted`,
            isArrivalHighlighted: `=?${DIRECTIVE_NAME}IsArrivalHighlighted`,
            isLogoHidden: `=?${DIRECTIVE_NAME}IsLogoHidden`,
            isFilterHidden: `=?${DIRECTIVE_NAME}IsFilterHidden`,
        },
        link: function($scope, $elem, $attrs, flightGroupCtrl) {
            flightGroupCtrl.$onInit();
        },
    };
}

export function AtcFlightGroupController(
    atcFlightsService,
    atcFlightGroupService,
    userService,
    l10nService,
    ) {
    'ngInject';

    const vm = this;
    const FILTER_BY_FLIGHT_TITLE = l10nService.localize('Show results with this flight only');

    Object.assign(vm, {
        $onInit,
        getAirlineLogo,
        getFlightStopsCode,
        getDepartureAirport,
        getArrivalAirport,
        getDepartureTime,
        getArrivalTime,
        getStopsCount,
        getCabinClass,
        getTouchdownCount,
        isStopAndTouchdownCountVisible,
        getJoinedStopsAndTouchdowns,
        getFlightTouchdownCodes,
        l10nService,
        FILTER_BY_FLIGHT_TITLE,
        getDayShiftArrival: atcFlightGroupService.getDayShiftArrival,
    });

    function $onInit() {
        vm.rs = userService.getRegionalSettings();
    }

    function getFlightTouchdownCodes() {
        return atcFlightGroupService.getFlightTouchdownCodes(vm.group)
            .join(', ');
    }

    function getJoinedStopsAndTouchdowns() {
        return atcFlightGroupService.getJoinedStopsAndTouchdowns(vm.group);
    }

    function isStopAndTouchdownCountVisible() {
        return getJoinedStopsAndTouchdowns().length > 0;
    }

    function getTouchdownCount() {
        return atcFlightGroupService.getTouchdownCount(vm.group);
    }

    function getAirlineLogo() {
        return atcFlightsService.getFlightSupplierLogo(vm.recommendation.MarketingCompanyCode);
    }

    function getFlightStopsCode() {
        return vm.group.FlightStops
            .map(({AirportCode}) => AirportCode)
            .join(', ');
    }

    function getStopsCount() {
        const number = vm.group.FlightStops.length;
        const label = number === 1 ? l10nService.localize('stop') : l10nService.localize('stops');
        return number ? `${number} ${label}` : '';
    }

    function getDepartureAirport() {
        return atcFlightGroupService.getFirstFlight(vm.group).DepartureAirport;
    }

    function getArrivalAirport() {
        return atcFlightGroupService.getLastFlight(vm.group).ArrivalAirport;
    }

    function getDepartureTime() {
        return atcFlightGroupService.getFirstFlight(vm.group).DepartureDate;
    }

    function getArrivalTime() {
        return atcFlightGroupService.getLastFlight(vm.group).ArrivalDate;
    }

    function getCabinClass() {
        return l10nService.localize(atcFlightGroupService.getCabinClass(vm.group, vm.recommendation));
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-segment/flight-group/flight-group-component.js